<ng-container *ngIf="dialog$ | async as dialog">
  <iframe style="border: none" width="100%" height="500" [src]="dialog.initialState.url | safe" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
</ng-container>
